import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import Logo from '../components/Logo';

const Auth = () => {
  const { login, signup } = useApp();
  const [tab, setTab] = useState('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (loading) return;
    setLoading(true);
    try {
      if (tab === 'login') {
        if (!username.trim() || password.length < 1) { setErr('Enter username and password'); setLoading(false); return; }
        await login({ username: username.trim().toLowerCase(), password });
      } else {
        if (username.trim().length < 4) { setErr('Username: min 4 chars'); setLoading(false); return; }
        if (password.length < 8) { setErr('Password: min 8 chars'); setLoading(false); return; }
        if (!displayName.trim()) { setErr('Display name required'); setLoading(false); return; }
        await signup({ display_name: displayName.trim(), username: username.trim().toLowerCase(), password });
      }
    } catch (e2) {
      setErr(e2?.response?.data?.detail || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center px-4 bg-[#050505] text-[#e6e6e6] font-mono">
      <div className="absolute inset-0 pointer-events-none opacity-[0.06]" style={{
        backgroundImage: 'linear-gradient(#22c55e 1px, transparent 1px), linear-gradient(90deg, #22c55e 1px, transparent 1px)',
        backgroundSize: '32px 32px',
      }} />
      <div className="relative w-full max-w-[420px] border border-[#1f1f1f] bg-[#0a0a0a] p-8 rounded-md shadow-[0_0_40px_rgba(34,197,94,0.05)]">
        <div className="mb-6">
          <Logo size={22} textSize={14} />
        </div>

        <h1 className="text-2xl font-semibold mb-2">{tab === 'login' ? 'Login' : 'Create Account'}</h1>
        <p className="text-[13px] text-[#8a8a8a] leading-relaxed mb-6">
          Sign in to use wallet, orders, and checkout. Open this store from the Telegram bot for automatic login.
        </p>

        <div className="grid grid-cols-2 gap-0 mb-6 border border-[#1f1f1f] rounded-md overflow-hidden">
          <button
            type="button"
            onClick={() => setTab('login')}
            className={`py-2.5 text-xs tracking-[0.2em] transition-colors ${tab === 'login' ? 'bg-[#22c55e] text-black font-semibold' : 'bg-transparent text-[#8a8a8a] hover:text-[#e6e6e6]'}`}
          >LOGIN</button>
          <button
            type="button"
            onClick={() => setTab('signup')}
            className={`py-2.5 text-xs tracking-[0.2em] transition-colors ${tab === 'signup' ? 'bg-[#22c55e] text-black font-semibold' : 'bg-transparent text-[#8a8a8a] hover:text-[#e6e6e6]'}`}
          >CREATE ACCOUNT</button>
        </div>

        <form onSubmit={submit} className="space-y-4">
          {tab === 'signup' && (
            <div>
              <label className="block text-[10px] tracking-[0.2em] text-[#8a8a8a] mb-1.5">DISPLAY NAME</label>
              <input
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="Your name"
                className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2.5 text-sm outline-none focus:border-[#22c55e] transition-colors"
              />
            </div>
          )}
          <div>
            <label className="block text-[10px] tracking-[0.2em] text-[#8a8a8a] mb-1.5">USERNAME</label>
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="username"
              className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2.5 text-sm outline-none focus:border-[#22c55e] transition-colors"
            />
          </div>
          <div>
            <label className="block text-[10px] tracking-[0.2em] text-[#8a8a8a] mb-1.5">PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full bg-transparent border border-[#1f1f1f] rounded-md px-3 py-2.5 text-sm outline-none focus:border-[#22c55e] transition-colors"
            />
          </div>
          {tab === 'signup' && (
            <p className="text-[11px] text-[#6a6a6a]">Username: 4-32 letters/numbers/underscore · Password: min 8 chars</p>
          )}
          {err && <p className="text-[12px] text-red-400">{err}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-2.5 rounded-md text-xs tracking-[0.2em] bg-[#166534] hover:bg-[#15803d] disabled:opacity-50 text-[#e7ffef] transition-colors"
          >
            {loading ? 'PLEASE WAIT…' : tab === 'login' ? 'LOGIN TO STORE' : 'CREATE ACCOUNT'}
          </button>
        </form>

        <div className="mt-6 pt-4 border-t border-[#1f1f1f] flex items-center justify-between text-[10px] tracking-[0.2em] text-[#5a5a5a]">
          <span>V1.4.2</span>
          <a href="/admin" className="hover:text-[#22c55e] transition-colors">ADMIN →</a>
        </div>
      </div>
    </div>
  );
};

export default Auth;
